import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function MissionSection() {
  return <section id="mission" className="py-20 bg-white" data-id="element-139">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8 flex justify-center" data-id="element-141">
          <div className="w-16 h-16 bg-[#0f5f5f]/10 rounded-full flex items-center justify-center text-[#0f5f5f]" data-id="element-142">
            <Scale size={32} data-id="element-143" />
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-4xl font-serif font-bold text-[#0f5f5f] mb-8" data-id="element-144">
          Our Mission
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-gray-700 leading-relaxed font-light" data-id="element-145">
          "We strive to create a fair and transparent gambling environment in
          Ukraine. Our mission is to protect the rights of players, promote
          responsible gaming practices, and provide support for those affected
          by gambling addiction."
        </motion.p>
      </div>
    </section>;
}